/**
 * Typy billboardów reklamowych dostępnych w grze
 */
export var BillboardType;
(function (BillboardType) {
    BillboardType["TEXT"] = "TEXT";
    BillboardType["IMAGE"] = "IMAGE"; // Billboard z obrazem
})(BillboardType || (BillboardType = {}));
/**
 * Konfiguracja systemu billboardów
 */
export const BILLBOARD_CONFIG = {
    DEFAULT_WIDTH: 10, // Domyślna szerokość billboardu
    DEFAULT_HEIGHT: 5, // Domyślna wysokość billboardu
    DEFAULT_TEXT_COLOR: '#000000', // Domyślny kolor tekstu
    DEFAULT_BG_COLOR: '#FFFFFF', // Domyślny kolor tła
    DEFAULT_FONT_SIZE: 0.5, // Domyślny rozmiar czcionki
    CLICK_COOLDOWN: 2000, // Czas odnowienia (ms) między kliknięciami
    INTERACTION_DISTANCE: 50 // Maksymalna odległość interakcji
};
